import { Component, Inject, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ToastService } from '../../../../../../projects/client/src/app/shared/services/toast.service';
import { JournalBasic } from '../../../services/mortgage-api.service';
import { fadeAnimation, sidepaneMove } from '../../../shared/animations/sidepane-animation';
import { IRequestFactFindService, REQUEST_FACTFIND_SERVICE } from './tokens/request-fact-find.tokens';

@Component({
  selector: 'hf-request-fact-find',
  templateUrl: './request-fact-find.component.html',
  styleUrls: ['./request-fact-find.component.scss', '../../../styles/components/sidepanes.partial.scss'],
  animations: [sidepaneMove, fadeAnimation],
  host: { '[@sidepaneMove]': 'true' }
})
export class RequestFactFindComponent implements OnDestroy {
  public get mortgageId(): string {
    return this.route.snapshot.params['id'];
  }

  public get requestFrom(): string[] {
    return this.requestFactFindService.requestFrom;
  }

  public isSubmitting = false;

  public form = new UntypedFormGroup({
    internalNotes: new UntypedFormControl(''),
    messageToClient: new UntypedFormControl('', Validators.required)
  });

  private destroy$ = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(REQUEST_FACTFIND_SERVICE) private requestFactFindService: IRequestFactFindService,
    private tostService: ToastService
  ) {}

  public ngOnDestroy() {
    this.destroy$.next();
  }

  public onBack() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }

  public async onRequest() {
    const value: JournalBasic = this.form.value;

    this.isSubmitting = true;

    try {
      await this.requestFactFindService.requestFactFind(this.route.snapshot.paramMap, value);

      this.tostService.add({ header: `Fact Find request sent.`, message: `${this.requestFrom?.join(', ')}` }, 'info');
      this.requestFactFindService.requested$.next();

      this.onBack();
    } catch (err) {
      this.tostService.add({ header: 'Failed to request Fact Find.', message: 'Please try again' }, 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
}
